import React, { useState, useEffect } from 'react';
import { useStartProfileMutation } from '../../redux/auth/authApiSlice';
import styles from './styles.module.css';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';

const normalizePhone = (value) => {
  if (!value) return '';
  let v = value.replace(/[^+0-9]/g,'').trim();
  if (v.startsWith('0')) v = '+46' + v.slice(1);
  if (!v.startsWith('+')) v = '+46' + v;
  return v;
};

const PhoneStep = ({ userId, onSuccess }) => {
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [cooldown, setCooldown] = useState(0);
  const [startProfile, { isLoading }] = useStartProfileMutation();

  useEffect(()=>{
    if (cooldown <=0) return; 
    const t = setTimeout(()=> setCooldown(cooldown-1),1000);
    return ()=> clearTimeout(t);
  },[cooldown]);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setInfo('');
    const normalized = normalizePhone(phone);
    if (normalized.length < 8) { setError('Ogiltigt nummer'); return; }
    try {
      await startProfile({ userId, phone: normalized }).unwrap();
      setInfo('Kod skickad');
      setCooldown(60);
      onSuccess(normalized);
    } catch (err) {
      if (err?.status === 409) setError('Numret används redan');
      else if (err?.status === 400) setError('Ogiltigt nummer');
      else setError('Tekniskt fel');
    }
  };

  const resend = async () => {
    if (cooldown>0) return;
    setError(''); setInfo('');
    try {
      await startProfile({ userId, phone: normalizePhone(phone) }).unwrap();
      setInfo('Ny kod skickad');
      setCooldown(60);
    } catch (err) {
      if (err?.status === 409) setError('Numret används redan');
      else if (err?.status === 400) setError('Ogiltigt nummer');
      else setError('Fel vid skick');
    }
  };

  return (
    <form onSubmit={submit} className={styles.pc_form}>
      <h2 className={styles.pc_header}>Komplettera profil</h2>
      <p className={styles.pc_sub}>Ange ditt mobilnummer för att verifiera</p>
      <PhoneInput
        defaultCountry="SE"
        value={phone}
        onChange={setPhone}
        className={styles.PhoneInput}
        placeholder="Telefonnummer"
      />
      {error && <div className={styles.pc_error}>{error}</div>}
      {info && <div className={styles.pc_info}>{info}</div>}
      <button type="submit" className={styles.pc_button_primary} disabled={isLoading}>Skicka kod</button>
      <button type="button" className={styles.pc_button_secondary} onClick={resend} disabled={cooldown>0}>{cooldown>0 ? `Skicka igen (${cooldown})` : 'Skicka igen'}</button>
    </form>
  );
};
export default PhoneStep;
